import Axios from 'axios';
import {localStorageKeyValue} from 'utils/handler';
import {baseUrl, requestHeader} from '../../config';
import {CatchReturnError} from "./actionHandler";
// requestHeader.Authorization = localStorage.getItem('saw-token') || ""

export const paymentStripe = (payload: any) => {
  return Axios.post(baseUrl + '/payments', payload, requestHeader).then(res => {
    let response = res['data']
    localStorage.removeItem(localStorageKeyValue.promoCode)
    return response
  }).catch(err => {
    CatchReturnError(err)
  })
}
export const payUsingPromoCode = (payload: any) => {
  return Axios.post(baseUrl + '/paymentUsingPromoCode', payload, requestHeader).then(res => {
    let response = res['data']
    localStorage.removeItem(localStorageKeyValue.promoCode)
    return response
  }).catch(err => {
    CatchReturnError(err)
  })
}

export const payUsingLeadPromoCode = (
  code: string,
  leadUID: string
) => {
  return Axios.post(baseUrl + '/paymentUsingLeadPromoCode', {code, leadUID}).then(res => {
    let response = res['data']
    return response
  }).catch(err => {
    CatchReturnError(err)
  })
}

export const getMyPaymentByLeadId = (leadUID: string) => {
  return Axios.get(baseUrl + '/getMyPaymentByLeadId/' + leadUID, requestHeader).then(res => {
    let response = res['data']
    return response
  }).catch(err => {
    CatchReturnError(err)
  })
}

export const stripeVerification = (payload: any) => {
  return Axios.post(baseUrl + '/stripeVerification', payload, requestHeader).then(res => {
    let response = res['data']
    return response
  }).catch(err => {
    CatchReturnError(err)
  })
}
